import React from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumberAsYouType } from '../../helpers/formatterHelper';
export function InactivatePhoneNumberConfirmationModal({ show, onClose, confirmInactivatePhoneNumber, model }) {
    const handleConfirmInactivatePhoneNumber = () => {
        if (model.title) {
            confirmInactivatePhoneNumber(model);
            onClose();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                <h2 className="admin-modal-heading">                    
                    {model?.body}
                </h2>
                <div className="admin-modal-row full">
                    <div className="admin-modal-cell">{formatPhoneNumberAsYouType(model?.title)}</div>
                </div>
                <div className="admin-modal-button-wrap">
                    <button className="admin-modal-button" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="admin-form-button power red"
                        onClick={handleConfirmInactivatePhoneNumber}

                    >
                        {model?.btnText}
                    </button>
                </div>
            </div>
        </div>
    );
}

InactivatePhoneNumberConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    confirmInactivatePhoneNumber: PropTypes.func.isRequired,
    model: PropTypes.object
};